import React from "react";
import shape1 from "../../assets/images/shape1.svg";
import shape2 from "../../assets/images/shape2.svg";
import shape3 from "../../assets/images/shape3.svg";
import dot from "../../assets/images/dot.png";
import whiteDot from "../../assets/images/white-dot.png";

const animationShapes = (
  <div className="animation-img">
    <img src={shape1} alt="" />
    <img src={shape2} alt="" />
    <img src={shape3} alt="" />
    <img src={shape1} alt="" />
    <img src={shape2} alt="" />
    <img src={shape3} alt="" />
    <img src={shape1} alt="" />
    <img src={shape3} alt="" />
  </div>
);

const dotImages = (
  <div className="dot-img">
    <img src={dot} alt="dot" className="color-dot" />
    <img src={whiteDot} alt="dot" className="white-dot" />
  </div>
);

class FeaturesTwo extends React.Component {
  render() {
    return (
      <section className="uk-features features-area uk-section uk-padding-remove-top">
        <div className="uk-container">
          <div className="uk-grid uk-grid-match uk-grid-medium uk-child-width-1-3@m">
            <div className="uk-item">
              <div className="single-features-box">
                <div className="icon">
                  <i className="flaticon-mail"></i>
                </div>
                <h3>Webサービスの開発</h3>
                <div className="bar"></div>
                <p>オーダーメイドのウェブサービスを作り上げます</p>
                {dotImages}
                {animationShapes}
              </div>
            </div>

            <div className="uk-item">
              <div className="single-features-box active">
                <div className="icon">
                  <i className="flaticon-targeting"></i>
                </div>
                <h3>Webサイト開発</h3>
                <div className="bar"></div>
                <p>
                  海外での経験が豊富なウィルクラウドだからこそできるウェブサイトのグローバル化や一般化を全面サポート致します
                </p>
                {dotImages}
                {animationShapes}
              </div>
            </div>

            <div className="uk-item">
              <div className="single-features-box">
                <div className="icon">
                  <i className="flaticon-magnifying-glass"></i>
                </div>
                <h3>SEO</h3>
                <div className="bar"></div>
                <p>WebサイトのSEOを最適化します</p>
                {dotImages}
                {animationShapes}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default FeaturesTwo;
